export class SearchbarModalOptions {
  constructor(public key: string, public value: string) {}
}
